import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getLTSummaryData = createApi(`GetLTSummaryDataSlice`,"GET");

const GetLTSummaryDataSlice = createSlice({
  name: 'GetLTSummaryDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLTSummaryData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLTSummaryData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getLTSummaryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetLTSummaryDataSlice.reducer;